// 请求头，拦截器
import Axios from "axios";
import store from "../store/index";
// import router from "../router/index";
const request = Axios.create({
    // baseURL: "http://youjiaminsu.cn:8808",
    // baseURL: "https://test.youjiaminsu.cn:333", //正式
    baseURL: "/api", //本地
    // baseURL: "http://192.168.18.121:8808", //熊总本地端口
    // baseURL: "http://192.168.18.105:8808", //翁正
    timeout: 200000 //请求超时时间
});

// 请求拦截器
// request.interceptors.request.use(
//   function(config) {
//     // config 本次请求的请求配置对象
//     const token = store.state.user;
//     const isToken = (config.headers || {}).isToken === false;
//     if (token && !isToken) {
//       config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带自定义token 请根据实际情况自行修改
//     }

//     return config;
//   },
//   function(error) {
//     return Promise.reject(error);
//   }
// );

// request拦截器
request.interceptors.request.use(
    config => {
        // 是否需要设置 token
        const token = store.state.user;
        const isToken = (config.headers || {}).isToken === false;
        if (token && !isToken) {
            config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        if (config.url == "/common/download"||config.url =='/wx/allotmentLandlord') {
            config.headers = {}
        }

        // get请求映射params参数
        if (config.method === "get" && config.params) {
            let url = config.url + "?";
            for (const propName of Object.keys(config.params)) {
                const value = config.params[propName];
                var part = encodeURIComponent(propName) + "=";
                if (value && typeof value !== "undefined") {
                    if (typeof value === "object") {
                        for (const key of Object.keys(value)) {
                            let params = propName + "[" + key + "]";
                            var subPart = encodeURIComponent(params) + "=";
                            url += subPart + encodeURIComponent(value[key]) + "&";
                        }
                    } else {
                        url += part + encodeURIComponent(value) + "&";
                    }
                }
            }
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    function(response) {
        console.log(response)
        const whiteUrl=['/system/user/restPwd']
        if (response.data.code === 401&&!whiteUrl.includes(response.config.url)) {
            sessionStorage.clear();
            location.href = "index.html#/login"; // token过期，重定向到登录页
        }

        return response;
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default request;
